import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { getHot } from "@/lib/content";
import { getCategoryMeta } from "@/mocks/categories";

const slides = getHot(4);
const hotList = getHot(6);

export default function FocusBanner() {
  const [current, setCurrent] = useState(0);
  const touchStartX = useRef(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((c) => (c + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const go = (dir: number) => {
    setCurrent((c) => (c + dir + slides.length) % slides.length);
  };

  return (
    <section className="w-full bg-background-50">
      <div className="w-full px-4 md:px-8 py-6 md:py-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
          {/* 焦点轮播 */}
          <div
            className="lg:col-span-2 relative rounded-xl overflow-hidden h-[260px] sm:h-[360px] md:h-[440px] group"
            onTouchStart={(e) => (touchStartX.current = e.touches[0].clientX)}
            onTouchEnd={(e) => {
              const diff = e.changedTouches[0].clientX - touchStartX.current;
              if (Math.abs(diff) > 50) go(diff > 0 ? -1 : 1);
            }}
          >
            {slides.map((slide, index) => {
              const meta = getCategoryMeta(slide.category);
              return (
                <Link
                  key={slide.id}
                  to={`/detail/${slide.id}`}
                  className={`absolute inset-0 transition-opacity duration-700 cursor-pointer ${
                    index === current ? "opacity-100 z-10" : "opacity-0 z-0"
                  }`}
                >
                  <img
                    src={slide.cover}
                    alt={slide.title}
                    className="w-full h-full object-cover object-top"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />
                  <div className="absolute bottom-0 left-0 right-0 p-5 md:p-8">
                    <span className="inline-block px-3 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium mb-3">
                      {meta?.name}
                    </span>
                    <h2 className="font-heading text-xl md:text-3xl font-black text-white leading-snug mb-2 md:mb-3 line-clamp-2">
                      {slide.title}
                    </h2>
                    <p className="hidden sm:block text-sm text-white/80 line-clamp-2 max-w-2xl">
                      {slide.summary}
                    </p>
                  </div>
                </Link>
              );
            })}

            {/* 左右控制 */}
            <button
              type="button"
              onClick={() => go(-1)}
              aria-label="上一条"
              className="absolute left-3 top-1/2 -translate-y-1/2 z-20 w-9 h-9 md:w-10 md:h-10 rounded-full bg-black/40 text-white flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity cursor-pointer"
            >
              <i className="ri-arrow-left-s-line text-xl" />
            </button>
            <button
              type="button"
              onClick={() => go(1)}
              aria-label="下一条"
              className="absolute right-3 top-1/2 -translate-y-1/2 z-20 w-9 h-9 md:w-10 md:h-10 rounded-full bg-black/40 text-white flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity cursor-pointer"
            >
              <i className="ri-arrow-right-s-line text-xl" />
            </button>

            {/* 指示点 */}
            <div className="absolute bottom-4 right-5 z-20 flex items-center gap-2">
              {slides.map((slide, index) => (
                <button
                  key={slide.id}
                  type="button"
                  aria-label={`第 ${index + 1} 条`}
                  onClick={() => setCurrent(index)}
                  className={`h-1.5 rounded-full transition-all cursor-pointer ${
                    index === current
                      ? "w-6 bg-primary-500"
                      : "w-2.5 bg-white/60"
                  }`}
                />
              ))}
            </div>
          </div>

          {/* 热点排行 */}
          <div className="rounded-xl bg-background-100 border border-background-200 p-5">
            <div className="flex items-center gap-2 mb-4">
              <i className="ri-fire-fill text-accent-500 text-lg" />
              <h3 className="font-heading text-lg font-black text-foreground-950">
                热点排行
              </h3>
            </div>
            <ul className="space-y-3.5">
              {hotList.map((item, index) => (
                <li key={item.id}>
                  <Link
                    to={`/detail/${item.id}`}
                    className="flex gap-3 group/item cursor-pointer"
                  >
                    <span
                      className={`shrink-0 w-6 h-6 rounded-md flex items-center justify-center text-xs font-bold ${
                        index < 3
                          ? "bg-primary-500 text-background-50"
                          : "bg-background-200 text-foreground-600"
                      }`}
                    >
                      {index + 1}
                    </span>
                    <span className="text-sm text-foreground-700 leading-snug line-clamp-2 group-hover/item:text-primary-600 transition-colors">
                      {item.title}
                    </span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}